import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from '@base/environments/environment';
import { Constants } from '../models/constants';
import { UserSessionService } from '../services/user-session.service';

// Nodes whose login and menu live in this app
export function usesAppLogin(): boolean {
  return (
    environment.node === Constants.TENANT_ID_AR ||
    environment.node === Constants.TENANT_ID_DO ||
    environment.node === Constants.TENANT_ID_EC ||
    environment.node === Constants.TENANT_ID_PY
  );
}

// Tells "never logged in / logged out" apart from "had a session that expired"
export function hasStoredSession(): boolean {
  const RAW = localStorage.getItem(UserSessionService.LOGGED_USER);
  if (!RAW) {
    return false;
  }
  try {
    return JSON.parse(RAW) != null;
  } catch {
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class RootRedirectGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): UrlTree {
    if (usesAppLogin() && !hasStoredSession()) {
      return this.router.createUrlTree(['/login']);
    }
    return this.router.createUrlTree(['/home']);
  }
}
